// Decode a JWT payload (the middle segment) to a plain object.
//
// JWTs are base64url-encoded (URL-safe alphabet, padding stripped), but the
// browser's atob() only accepts standard base64 — so a token whose payload
// happens to contain a '-' or '_' (common: random claim values, some tenant
// ids) makes a raw atob() throw, and any caller that treated that as "no claim"
// silently fails OPEN. Normalise to standard base64 + re-pad first.
//
// Returns null on any malformed/empty token rather than throwing, so callers
// can treat "can't decode" uniformly as "no claim".
export function decodeJwtPayload(token: string | undefined | null): Record<string, unknown> | null {
  if (!token) return null
  try {
    const seg = token.split('.')[1]
    if (!seg) return null
    let b64 = seg.replace(/-/g, '+').replace(/_/g, '/')
    b64 += '='.repeat((4 - (b64.length % 4)) % 4)
    return JSON.parse(atob(b64)) as Record<string, unknown>
  } catch {
    return null
  }
}
